import {
    CancelDialogActions,
    ImageCancelDialogLayout,
    CancelModal,
    CancelDialogMessageLayout,
  } from '@Components/shared/dialogs/CancelDialog';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';
import { useDispatch } from 'react-redux';
  
  export const SetupUserDrawerCancelDialog: React.FC = () => {
    const dispatch = useDispatch();
    const { showCancelUserDrawer, setShowCancelUserDrawer, handleCancelChanges } =
      useUserDrawer();
  
    return (
      <>
        {showCancelUserDrawer && (
          <CancelModal open={showCancelUserDrawer}>
            <ImageCancelDialogLayout
              title="Cancel user changes?"
              actions={
                <CancelDialogActions
                  onReject={() => dispatch(setShowCancelUserDrawer(false))}
                  onConfirm={handleCancelChanges}
                />
              }
            >
              <CancelDialogMessageLayout>
                You are about to delete all the changes you have made in user settings
              </CancelDialogMessageLayout>
            </ImageCancelDialogLayout>
          </CancelModal>
        )}
      </>
    );
  };
  